export const DESKTOP_MIN_WIDTH = 1024;

export const prefersReducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
